import React from 'react';
import styled from 'styled-components';

const ContainerMain = styled.div`
  width: 100%;
  height: 100%;
  align-content: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  padding: 1rem;
`;

const StyledHeading = styled.h1`
  color: var(--color-grey-500);
  color: lightblue; 
  justify-self: center;  
  margin-bottom: -1rem;
`;


function PreviewTeaser() {
  return (
    <ContainerMain>
      <StyledHeading>Candlestick chart</StyledHeading>

    </ContainerMain>
  );
}

export default PreviewTeaser;